export const DEFAULT_CALENDAR_FORMATS = {
  lastDay: '[Yesterday at] LT',
  sameDay: '[Today at] LT',
  nextDay: '[Tomorrow at] LT',
  lastWeek: 'MMM DD, YYYY [at] LT',
  nextWeek: 'MMM DD, YYYY [at] LT',
  sameElse: 'MMM DD, YYYY [at] LT'
};
